import { render } from "./PackagesOverview.vue?vue&type=template&id=6d0ca7d6&ts=true"
import script from "./PackagesOverview.vue?vue&type=script&lang=ts"
export * from "./PackagesOverview.vue?vue&type=script&lang=ts"

import "./PackagesOverview.vue?vue&type=style&index=0&id=6d0ca7d6&lang=css"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__